var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 303,
    viewBox: "0 0 216 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44_2427)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.3848,
    y: 153.839,
    width: 13.0851,
    height: 46.1421,
    fill: "url(#paint0_linear_44_2427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7402 56.4329H5.38379C5.3838 87.7281 7.78379 105.73 52.3725 105.73",
    stroke: "#FFDD66",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.937 97.4213C160.937 130.154 134.402 156.688 101.669 156.688C68.9371 156.688 42.4023 130.154 42.4023 97.4213C42.4023 64.6889 68.9371 38.1541 101.669 38.1541C134.402 38.1541 160.937 64.6889 160.937 97.4213Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.669 197.677C77.5026 197.677 57.9115 204.745 57.9115 213.463H145.427C145.427 204.745 125.836 197.677 101.669 197.677Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4023 26.7637H160.937V94.6518H42.4023V26.7637Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.427 216.509H57.9115V213.186H145.427V216.509Z",
    fill: "#FFDD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.261 56.4329H199.617C199.617 87.7281 197.217 105.73 152.628 105.73",
    stroke: "#DE9300",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.937 97.4214C160.937 130.154 134.402 156.689 101.67 156.689C101.67 156.689 101.67 130.154 101.67 97.4214C101.67 64.6891 101.67 38.1543 101.67 38.1543C134.402 38.1543 160.937 64.6891 160.937 97.4214Z",
    fill: "url(#paint1_linear_44_2427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.67 197.677C101.67 197.677 101.67 204.745 101.67 213.463H145.428C145.428 204.745 125.837 197.677 101.67 197.677Z",
    fill: "url(#paint2_linear_44_2427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.67 26.7683H160.937V94.652H101.67V26.7683Z",
    fill: "url(#paint3_linear_44_2427)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.428 216.51H101.67C101.67 216.51 101.571 214.48 101.67 213.186C102.964 196.147 145.428 213.186 145.428 213.186V216.51Z",
    fill: "url(#paint4_linear_44_2427)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.833,
    cy: 90.8241,
    r: 35.4674,
    fill: "#DCAE0C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.762,
    cy: 90.3869,
    r: 42.2857,
    fill: "#DE9300",
    stroke: "#FFE176",
    strokeWidth: 4.55437
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.763 61.2285L111.748 79.2004L129.72 81.4469L117.38 95.2852L120.734 115.144L102.763 106.158L84.7906 115.144L88.1753 95.2852L75.8047 81.4469L93.7766 79.2004L102.763 61.2285Z",
    fill: "#FFF4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.657 60.7813L102.763 58.9924L101.868 60.7813L93.1215 78.2745L75.6807 80.4546L73.7878 80.6912L75.0592 82.1133L87.1086 95.5924L83.8048 114.976L83.4734 116.921L85.2378 116.039L102.763 107.276L120.287 116.039L122.048 116.919L121.72 114.978L118.446 95.5923L130.467 82.1124L131.734 80.6909L129.844 80.4546L112.404 78.2745L103.657 60.7813Z",
    stroke: "#C98500",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4296 41.262L35.6791 27.508L29.4296 13.754L43.1836 20.0035L56.9376 13.754L50.6881 27.508L56.9376 41.262L43.1836 35.0125L29.4296 41.262Z",
    fill: "#5575F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9756 229.029C39.9756 220.645 46.7725 213.848 55.1568 213.848H148.936C157.321 213.848 164.118 220.645 164.118 229.029V277.439H39.9756V229.029Z",
    fill: "#5575F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.0574,
    y: 231.536,
    width: 88.5093,
    height: 30.1924,
    fill: "#F9B50E",
    stroke: "#FFEC86",
    strokeWidth: 3.91749
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7012 229.577H105.513L138.523 263.687H96.7107L63.7012 229.577Z",
    fill: "#FFEC86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.0791,
    y: 277.439,
    width: 137.936,
    height: 13.2038,
    fill: "#DE9300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_2427",
    x: 0.100291,
    y: 12.9704,
    width: 215.769,
    height: 289.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_2427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_2427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_2427",
    x1: 101.927,
    y1: 153.839,
    x2: 101.927,
    y2: 199.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C07F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_2427",
    x1: 160.529,
    y1: 86.5359,
    x2: 101.112,
    y2: 86.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_2427",
    x1: 160.529,
    y1: 86.5359,
    x2: 101.112,
    y2: 86.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_2427",
    x1: 160.529,
    y1: 86.5359,
    x2: 101.112,
    y2: 86.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_2427",
    x1: 160.529,
    y1: 86.5359,
    x2: 101.112,
    y2: 86.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e44193d853fa57468c57c9b0387c47be.svg";
export { ForwardRef as ReactComponent };